// import { ReactComponent as Quizz } from "../images/contenticon/quiz1.svg";
// import { ReactComponent as Settings } from "../images/contenticon/setting.svg";
// import { ReactComponent as ReviewRating } from "../images/contenticon/review&rating.svg";
// import { ReactComponent as UploadPlans } from "../images/contenticon/uploadplans.svg";
// import { ReactComponent as Notes } from "../images/contenticon/notes.svg";
import   examIcon  from "../../images/exam.svg";
// import { ReactComponent as ClientExamVector } from "../images/manageicon/clientexam.svg";
// import { ReactComponent as Batch } from "../images/manageicon/batchicon.svg";
// import { ReactComponent as LearnerIcon } from "../images/manageicon/learnericon.svg";
// import { ReactComponent as AssignExamToBatch } from "../images/manageicon/assignexamtobatch.svg";

const sidePannelData = [
  {
    id: 79,
    name: "My Exam",
    type: "link",
    icon: examIcon,
    path: "/myexam",
    validity: true,
    page_status: true,
  },
];
export default sidePannelData;
